import { render, staticRenderFns } from "./CollectionsAdd.vue?vue&type=template&id=03f73cf6&scoped=true&"
import script from "./CollectionsAdd.vue?vue&type=script&lang=js&"
export * from "./CollectionsAdd.vue?vue&type=script&lang=js&"
import style0 from "./CollectionsAdd.vue?vue&type=style&index=0&id=03f73cf6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03f73cf6",
  null
  
)

export default component.exports